import { afterNextRender, Component, DestroyRef, inject, input, signal } from '@angular/core';

@Component({
    selector: 'ui-scroll-buttons',
    styles: [`
        :host {
            display: none;
            opacity: 50%;
            position: absolute;
            bottom: 2em;
            text-align: center;
            left: 0;
            width: 100%;
            z-index: 100;
            pointer-events: none;
        }
        button {
            border: none;
            font-size: 1.8em;
            background: black;
            color: white;
            pointer-events: auto;
        }
        button:first-child {
            border-top-left-radius: 50em;
            border-bottom-left-radius: 50em;
            padding-right: 0.75em;
            padding-left: 0.5em;
        }
        button:last-child {
            border-top-right-radius: 50em;
            border-bottom-right-radius: 50em;
            padding-left: 0.75em;
            padding-right: 0.5em;
        }
        @media (min-width: 768px) {
            :host {
                display: block;
            }
        }
    `],
    template: `
        @if (hasOverflow()) {
            <button type="button" (click)="scroll(-1)" aria-label="Scroll left"><i class="fa fa-angle-left"></i></button>
            <button type="button" (click)="scroll(1)" aria-label="Scroll right"><i class="fa fa-angle-right"></i></button>
        }
    `,
})
export class ScrollButtonsComponent {

    hasOverflow = signal(false);

    target = input.required<HTMLElement>();

    private destroyRef = inject(DestroyRef);

    constructor() {
        afterNextRender(() => {
            const el = this.target();

            const checkOverflow = () => {
                this.hasOverflow.set(el.scrollWidth > el.clientWidth + 1);
            };

            const observer = new ResizeObserver(checkOverflow);

            observer.observe(el);

            checkOverflow();

            this.destroyRef.onDestroy(() => observer.disconnect());
        });
    }

    scroll(direction: -1 | 1) {
        const el = this.target();
        el.scrollTo({
            left: el.scrollLeft + direction * 300,
            behavior: 'smooth',
        });
    }
}
